import labelFilter from './atom';

export default labelFilter;
